
export enum UniformVariantType {
    Base,
    Variant1,
    Variant2,
    Variant3,
    Variant4,
    Variant5,
    Variant6
}